<div class="c-endGameReward">
  <div
    class="c-endGameReward__bg"
    theming
    themingGroup="progressline"
    themingAsset="last-milestone">
    <div class="c-endGameReward__content">
      @if (!endGameMilestone()) {
        <div
          class="status"
          theming
          themingGroup="none"
          themingAsset="lock"></div>
        <div
          class="reward"
          theming
          themingGroup="progressline"
          themingAsset="end-reward-off"></div>
        <div class="message">{{ 'home.progress-line.more-rewards' | translate }}</div>
      } @else {
        <div
          class="reward"
          theming
          themingGroup="progressline"
          [themingAsset]="prizeUI()?.icon === 'soft' ? 'end-reward-soft' : 'end-reward-hard'"></div>

        <slotcom-progress-bar
          [classes]="['c-progress-bar--endGameReward']"
          [currentProgress]="casino().current"
          [totalProgress]="endGameMilestone().requiredPrestigePoints"
          [completed]="casino().current >= endGameMilestone().requiredPrestigePoints">
          <div
            class="c-progress--prestige"
            progressBarIcon
            progressBarIconPos="left"
            theming
            themingGroup="progressline"
            themingAsset="prestige-logo"></div>
          {{ casino().current | notRoundingBeautifyNumber: ('common.culture' | translate) }} /
          {{ endGameMilestone().requiredPrestigePoints | notRoundingBeautifyNumber: ('common.culture' | translate) }}
        </slotcom-progress-bar>

        <slotcom-display [classes]="['c-display--milestone']">
          <div
            displayIcon
            displayIconPos="left"
            [ngClass]="prizeUI()?.icon === 'hard' ? 'c-display--gem' : 'c-display--coin'"></div>
          {{ prizeUI()?.text | notRoundingBeautifyNumber: ('common.culture' | translate) }}
        </slotcom-display>

        <div class="message">
          {{ 'home.progress-line.last-milestone' | translate }}
        </div>
      }
    </div>
  </div>
</div>
